import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import { ApplyStampPayload } from '../../../models/parking/discount-apply.model';

@Injectable({ providedIn: 'root' })
export class ApiDiscountApplyService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  searchByLicense(license: string, siteId = 0): Observable<unknown> {
    const params: Record<string, string | number> = { license };
    if (siteId > 0) params['siteId'] = siteId;
    return this.apiMethodService.request('/Discount/searchByLicense', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'Discount.searchByLicense',
      token: this.token,
      headerOnly: false,
      params,
    });
  }

  getTransactionDetailByCardCode(cardCode: string, siteId: number, userId: number): Observable<unknown> {
    return this.apiMethodService.request('/Discount/getTransactionDetailByCardCode', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'Discount.getTransactionDetailByCardCode',
      token: this.token,
      headerOnly: false,
      params: { cardCode, siteId, userId },
    });
  }

  getAvailableStamps(userId: number, transactionId: number): Observable<unknown> {
    return this.apiMethodService.request('/Discount/getAvailableStamps', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'Discount.getAvailableStamps',
      token: this.token,
      headerOnly: false,
      params: { userId, transactionId },
    });
  }

  applyStamp(body: ApplyStampPayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request('/Discount/applyStamp', 'POST', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'Discount.applyStamp',
      token: this.token,
      headerOnly: false,
      body,
    });
  }
}
